var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("synced "),_c('humanize-time',{attrs:{"time":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }